// Class strings for the coach-link screens, per DESIGN.md: borders not shadows,
// 44px buttons, 6px button/input radius, 8px cards. The CSS variables swap for dark mode.

export const btnPrimary =
  'inline-flex min-h-[44px] items-center justify-center gap-2 rounded-md px-4 text-[13px] font-semibold bg-forest-ondark text-white dark:text-canvas-dark hover:opacity-90 active:scale-[0.98] transition duration-120 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-2 focus-visible:ring-offset-canvas disabled:opacity-50 disabled:pointer-events-none';

export const btnSecondary =
  'inline-flex min-h-[44px] items-center justify-center gap-2 rounded-md px-4 text-[13px] font-medium border border-line text-ink bg-transparent hover:bg-moss active:scale-[0.98] transition duration-120 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-2 focus-visible:ring-offset-canvas disabled:opacity-50 disabled:pointer-events-none';

export const btnGhost =
  'inline-flex min-h-[44px] items-center justify-center gap-2 rounded-md px-3 text-[13px] font-medium text-ink hover:bg-moss transition duration-120 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-forest disabled:opacity-50';

export const card = 'rounded-lg border border-line bg-surface';

export const input =
  'w-full min-h-[44px] rounded-md border border-line bg-surface px-3 text-[13px] text-ink placeholder:text-ink-muted outline-none transition duration-120 focus:border-forest focus:ring-2 focus:ring-forest/30';

export const inputError = 'border-[color:var(--danger-text)] focus:border-[color:var(--danger-text)]';

export const label = 'block text-[13px] font-medium text-ink mb-1.5';
export const hint = 'text-[11px] text-ink-muted';
export const errorText = 'text-[11px] font-medium text-[color:var(--danger-text)]';
export const sectionTitle = 'text-[15px] font-semibold text-ink';
export const pageTitle = 'font-display text-[28px] sm:text-[36px] font-medium leading-tight text-ink';
